import { equalWithinTolerance } from './equalsWithinTolerance';

export const forceToleranceInPounds = 1;

export function forceEquals(forceOneInPounds: number, forceTwoInPounds: number) {
  return equalWithinTolerance(forceOneInPounds, forceTwoInPounds, forceToleranceInPounds);
}

export function forceGreaterThanOrEqual(forceOneInPounds: number, forceTwoInPounds: number) {
  return forceOneInPounds >= forceTwoInPounds || forceEquals(forceOneInPounds, forceTwoInPounds);
}

export function forceLessThanOrEqual(forceOneInPounds: number, forceTwoInPounds: number) {
  return forceOneInPounds <= forceTwoInPounds || forceEquals(forceOneInPounds, forceTwoInPounds);
}

export function forceGreaterThan(forceOneInPounds: number, forceTwoInPounds: number) {
  return !forceLessThanOrEqual(forceOneInPounds, forceTwoInPounds);
}

export function forceLessThan(forceOneInPounds: number, forceTwoInPounds: number) {
  return !forceGreaterThanOrEqual(forceOneInPounds, forceTwoInPounds);
}
